import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { aiContentFields } from '../../../../contentBriefsConstants';

import { getThemeColorClass } from '../../../../../../../../../../utils/helpers/themeHelpers';
import useOutlineVersions from '../../../../../../../../../common/tiptapEditor/hooks/outline/useOutlineVersions';

import { selectDarkMode } from '../../../../../../../../../../userBrowserSettings/store/browserSettings.selectors';
import { editorTypes } from '../../../../../../../../../common/tiptapEditor/constants/tiptapEditorConstants';
import {
    selectCurrentEditorContent,
    selectCurrentEditorLoading,
    selectEditorFullWidth,
} from '../../../../../../../../../common/tiptapEditor/store/tiptapEditor.selectors';

import {
    selectAIContentLoadingField,
    selectAIContentLoadingProgress,
    selectAIOutlineLoadingProgress,
} from '../../store/contentBriefsOutline.selectors';
import { setAIContentLoadingProgress } from '../../store/contentBriefsOutline.actions';

import NewRankabilityLoader from '../../../../../../../../../common/rankabilityLoader/NewRankabilityLoader';
import SkeletonLoading from '../../../../../../../../../common/SkeletonLoading';
import OutlineEditor from '../../../../../../../../../common/tiptapEditor/OutlineEditor';

import './Optimizer.scss';

const classes = {
    tiptapEditorWrapper: 'tiptap-editor-wrapper outline-editor-wrapper turn-on-editor-html-tags',
    tiptapEditorLoader: 'tiptap-editor-loader',
};

const editorType = editorTypes.OUTLINE;

const OutlineOptimizerContainer = () => {
    const { contentOptimizerId } = useParams();

    const darkMode = useSelector(selectDarkMode);
    const editorFullWidth = useSelector(selectEditorFullWidth(editorType));
    const currentEditorContent = useSelector(selectCurrentEditorContent(editorType));
    const currentEditorLoading = useSelector(selectCurrentEditorLoading(editorType));
    const aiContentLoadingField = useSelector(selectAIContentLoadingField);
    const aiContentLoadingProgress = useSelector(selectAIContentLoadingProgress);
    const aiOutlineLoadingProgress = useSelector(selectAIOutlineLoadingProgress);

    const { fetchOutlineVersions } = useOutlineVersions();

    useEffect(() => {
        fetchOutlineVersions();

        // eslint-disable-next-line
    }, [contentOptimizerId]);

    return (
        <>
            {!currentEditorLoading && currentEditorContent ? (
                <div
                    className={`${classes.tiptapEditorWrapper} ${
                        editorFullWidth ? 'turn-on-editor-full-width' : ''
                    } ${getThemeColorClass(darkMode)}`}
                >
                    {Boolean(aiContentLoadingField) && (
                        <NewRankabilityLoader
                            currentProgress={
                                aiContentLoadingField === aiContentFields.OPTIMIZER
                                    ? aiContentLoadingProgress
                                    : aiOutlineLoadingProgress
                            }
                            absolute
                            className={classes.tiptapEditorLoader}
                            aiContentLoadingField={aiContentLoadingField}
                            dispatchHandler={
                                aiContentLoadingField === aiContentFields.OPTIMIZER
                                    ? setAIContentLoadingProgress
                                    : null
                            }
                        />
                    )}
                    <OutlineEditor />
                </div>
            ) : (
                <SkeletonLoading width='98%' />
            )}
        </>
    );
};

export default OutlineOptimizerContainer;
